module.exports = "/_next/static/images/c10b093c0af950efe1208e885992f795-mgm-invite-ticket-1.jpg.webp";